import * as React from 'react';
import * as styled from './styled';
import {IconRoundPlus} from 'icons';

/**
 * The simple button with add icon.
 * @param {React.HTMLAttributes<HTMLButtonElement>} props
 * @return {React.ReactElement<React.HTMLAttributes<HTMLButtonElement>>}
 * @constructor
 */
export default function PushButton(
    props: React.HTMLAttributes<HTMLButtonElement>,
): React.ReactElement<React.HTMLAttributes<HTMLButtonElement>> {
  return (
    <styled.Wrapper type="button" {...props}>
      <IconRoundPlus />
      {props.children}
    </styled.Wrapper>
  );
}
